import { useFormik } from "formik";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { encryptData, setItem, Storage } from "../../Services/Storage";
import { Axios } from "../../Services/Axios/index";
import * as yup from "yup";
import { FiMail, FiLock, FiArrowRight } from "react-icons/fi";
import Loader from "../../Components/loader";

const validationSchema = yup.object({
  username: yup
    .string("Enter a valid value...")
    .required("This value is required..."),
  password: yup
    .string("Enter your password...")
    .required("Enter your password..."),
});

const adminPermissions = [
  {
    title: "Cities",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Centers",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Course Inquiry",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Placements",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "POM",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "SOM",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Upcoming Batches",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Events",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Course",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Semester",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Books",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Tickets",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Statuses",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Issues",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Orders",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
  {
    title: "Settings",
    allRights: 0,
    canView: true,
    canAdd: true,
    canUpdate: true,
    canDelete: true,
  },
];

export const Login = () => {
  const [loading, setLoading] = React.useState(false);
  const [axiosError, setAxiosError] = React.useState(undefined);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setLoading(true);
      Axios.post("/Users/login", values)
        .then((res) => {
          if (res?.data?.users?.role === "center") {
            setItem("center", res?.data?.center);
            dispatch({
              type: "setCenter",
              payload: encryptData(res?.data?.center),
            });
          }

          setLoading(false);
          setItem("token", res?.data?.token);
          Storage.setItem("user", res?.data?.users);
          Storage.setItem("center", res?.data?.center);
          setItem("role", { role: res?.data?.users?.role });
          setItem("name", { role: res?.data?.users?.name });
          dispatch({ type: "setLogin", payload: encryptData(true) });
          dispatch({ type: "setUser", payload: encryptData(res?.data?.users) });
          dispatch({
            type: "setRole",
            payload: encryptData({ role: res?.data?.users?.role }),
          });
          navigate("/");
        })
        .catch((err) => {
          setSubmitting(false);
          setLoading(false);
          if (err?.response?.status) {
            setAxiosError(err?.response?.data);
          }
        });
    },
  });

  return (
    <section className="fixed inset-0 z-50 min-h-screen flex items-center justify-center bg-gray-50 font-[Poppins] overflow-y-auto">
      <div className="flex flex-col md:flex-row w-full max-w-5xl bg-white shadow-2xl rounded-2xl overflow-hidden min-h-[600px] border border-gray-100 m-4">

        {/* Left Side: Form */}
        <div className="flex-1 p-10 sm:p-14 flex flex-col justify-center">
          <div className="mb-10 text-center md:text-left">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome back</h1>
            <p className="text-gray-500 text-sm">Please enter your details to sign in.</p>
          </div>

          <form onSubmit={formik.handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-900 mb-2" htmlFor="username">
                Email or username
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                  <FiMail />
                </div>
                <input
                  type="text"
                  id="username"
                  name="username"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`w-full pl-10 pr-4 py-3 border ${formik.touched.username && formik.errors.username
                    ? "border-[#E52C31]"
                    : "border-gray-200 focus:border-[#FCC90D]"
                    } rounded-lg bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#FCC90D]/50 transition-colors text-gray-900`}
                  placeholder="Enter your email"
                  autoComplete="username"
                />
              </div>
              <p className="text-[#E52C31] text-xs mt-1 min-h-[16px]">
                {formik.touched.username && formik.errors.username}
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-900 mb-2" htmlFor="password">
                Password
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                  <FiLock />
                </div>
                <input
                  type="password"
                  id="password"
                  name="password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`w-full pl-10 pr-4 py-3 border ${formik.touched.password && formik.errors.password
                    ? "border-[#E52C31]"
                    : "border-gray-200 focus:border-[#FCC90D]"
                    } rounded-lg bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#FCC90D]/50 transition-colors text-gray-900`}
                  placeholder="Enter your password"
                  autoComplete="password"
                />
              </div>
              <p className="text-[#E52C31] text-xs mt-1 min-h-[16px]">
                {formik.touched.password && formik.errors.password}
              </p>
            </div>

            {axiosError && (
              <div className="bg-[#E52C31]/10 text-[#E52C31] px-4 py-2 rounded-md text-sm text-center">
                {axiosError}
              </div>
            )}

            <button
              type="submit"
              disabled={!formik.isValid}
              className="w-full flex items-center justify-center gap-2 bg-[#FCC90D] hover:bg-[#e6b60c] text-gray-900 font-semibold py-3 rounded-lg transition-all duration-200 shadow-lg shadow-[#FCC90D]/30 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {formik.isSubmitting ? (
                <>
                  <Loader size={"size-5"} /> Loading...
                </>
              ) : (
                <>
                  Sign in <FiArrowRight />
                </>
              )}
            </button>
          </form>

          <div className="mt-12 text-center">
            <p className="text-gray-500 text-xs">&copy; MAAC {new Date().getFullYear()}. All rights reserved.</p>
          </div>
        </div>

        {/* Right Side: Image/Branding */}
        <div className="flex-1 relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#E52C31] to-[#FCC90D] min-h-[400px]">
          <div className="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>

          <div className="relative z-10 flex flex-col items-center justify-center p-12 text-center">
            <div className="mb-8">
              <img
                src={process.env.PUBLIC_URL + "/white-logo.png"}
                alt="Logo"
                className="max-w-[320px] drop-shadow-2xl"
              />
            </div>
            {/* <h2 className="mt-8 text-3xl font-bold text-white drop-shadow-md">
              Manage your center efficiently.
            </h2>
            <p className="mt-3 text-white/90 max-w-sm text-lg">
              Access all the tools and insights you need to streamline operations and drive success.
            </p> */}
          </div>
        </div>
      </div>
    </section>
  );
};
